class AnnouncementBarComponent extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.slides = this.querySelectorAll('.announcement-bar__slide');
    this.prevButton = this.querySelector('.announcement-bar__arrow--prev');
    this.nextButton = this.querySelector('.announcement-bar__arrow--next');
    this.autoplaySpeed = parseInt(this.getAttribute('autoplay')) * 1000 || 5000;
    this.autoplayTimer = null;

    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    // Show first slide
    this.showSlide(0);

    // Button events
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }

    // Start autoplay if enabled
    if (this.hasAttribute('autoplay')) {
      this.startAutoplay();
      
      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  showSlide(index) {
    // Hide all slides
    this.slides.forEach(slide => {
      slide.setAttribute('aria-hidden', 'true');
      slide.style.display = 'none';
    });

    // Show current slide
    if (this.slides[index]) {
      this.slides[index].setAttribute('aria-hidden', 'false');
      this.slides[index].style.display = 'flex';
      this.currentSlide = index;
    }
  }

  nextSlide() {
    let next = this.currentSlide + 1;
    if (next >= this.slides.length) next = 0;
    this.showSlide(next);
    this.resetAutoplay();
  }

  prevSlide() {
    let prev = this.currentSlide - 1;
    if (prev < 0) prev = this.slides.length - 1;
    this.showSlide(prev);
    this.resetAutoplay();
  }

  startAutoplay() {
    if (!this.hasAttribute('autoplay')) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.nextSlide(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {
    if (this.hasAttribute('autoplay')) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
}

customElements.define('announcement-bar-component', AnnouncementBarComponent);